import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import TravelPackages from './pages/TravelPackages';
import TravelPackagesCraft from './pages/TravelPackagesCraft';
import TravelPackagesCraftIndia from './pages/TravelPackagesCraftIndia';
import PackageDetail from './pages/PackageDetail';
import PackageDetailCraft from './pages/PackageDetailCraft';
import PackageDetailCraftIndia from './pages/PackageDetailCraftIndia';
import './App.css';
import Footer from './components/Footer';
import Copyright from './components/Copyright';
import Helmet from "react-helmet";
import $ from 'jquery';
window.$ = window.jQuery = $;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]); // Rerun effect when pathname changes
  return null; // This component doesn't render anything
}

function App() {
  return (
    <>
<Router> 
<Helmet>
    <title>Homepage</title>
                
</Helmet>

<Navbar />
<ScrollToTop />
<Routes>
   
  <Route path='/'  element={<Home />}/>
  <Route path='/aboutUs' element={<AboutUs />}/>
  <Route path='/travelpackages/:loc' element={<TravelPackages />}/>
  <Route path='/packagedetail/:loc/:pack_url' element={<PackageDetail />}/>
  <Route path='/travelpackagescraft/:loc' element={<TravelPackagesCraft />}/>
  <Route path='/packagedetailcraft/:loc/:pack_url' element={<PackageDetailCraft />}/>

  <Route path='/travelpackagescraftIndia/:loc' element={<TravelPackagesCraftIndia />}/>
  <Route path='/packagedetailcraftIndia/:loc/:pack_url' element={<PackageDetailCraftIndia />}/>
</Routes>
<Footer />
<Copyright />
</Router>
    </>
  );
}

export default App;
